<template>
	<section class="app-container">
		<div class="container projects-container">
			<div class="projects-component">
				<h1>Odonata Central Projects</h1>
				<div class="pull-right text-right">
					<div class="row">
						<div class="col-xs-8">
							<input type="text" v-model="pending_search" v-on:keyup.enter="doSearch" />
						</div>
						<div class="col-xs-4">
							&nbsp;<a class="btn btn--sm" @click="doSearch">Search</a>
						</div>
					</div>
				</div>
				<div v-bind:class="{ overlayLoading: loading }">
					<Paging></Paging>
					<PagingSummary v-model="meta"></PagingSummary>
					<div class="loading-overlay" v-show="loading">
						<div class="spinner-wrapper">
							<span class="spinner-text">LOADING</span>
							<span class="spinner"></span>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table-records border--round table--alternate-row">
							<thead>
								<tr>
									<column-sort column-id="name" column-name="Name" v-on:sortChange="doSort" />
									<column-sort column-id="start_date" column-name="Begin Date" v-on:sortChange="doSort" />
									<column-sort column-id="stop_date" column-name="End Date" v-on:sortChange="doSort" />
									<th>Contact</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="project in projects" :key="project.id" :class="'project-row'">
									<td>{{project.name}}</td>
									<td>{{project.start_date | formatStringDateYYYMMDD}}</td>
									<td>{{project.stop_date | formatStringDateYYYMMDD}}</td>
									<td>
										<span v-if="project.email">{{project.email}}</span>
										<span v-else><em>login for contact information</em></span>
									</td>
									<td>
										<div v-if="project.description">
											<button class="btn btn--sm" @click="openDetailsModal(project.id)">Details</button>
											<div :id="'popupDescription' + project.id" class="modal-content mfp-hide">
												<div class="modal-close modal-close-cross">
												</div>
												<section class="feature-large bg--white border--round ">
													<div class="container project-description-modal">
														<h2>{{project.name}}</h2><hr />	
														<div v-html="project.description"></div>
													</div>
												</section>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Paging></Paging>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'ProjectsComponent',
	metaInfo: {
      title: 'Dragonfly & Odonate Projects',
      meta: [
        { name: "description", content: 'Dragonfly & Odonate Projects' },
      ],
    },
	mounted(){
		var self = this;
		
        var parsed_page = parseInt(self.$route.query.page);
		if (!isNaN(parsed_page)) {
			self.page = parsed_page;
		}
		if (self.$route.query.sort) {
			self.sort = self.$route.query.sort;
		}
		if (self.$route.query.sort_direction) {
			if (self.$route.query.sort_direction == "+") {
				self.sort_direction = "";
			}
			else if (self.$route.query.sort_direction == "-") {
				self.sort_direction = "-";
			}
		}
		if (self.$route.query.search) {
			self.pending_search = self.$route.query.search;
			self.search = self.$route.query.search;
		}
		self.supress_requests = false;
		self.getData();
	},
	data: function(){
		return {
			projects: [],
			meta: {
				page: 0,
				per_page: 0,
				total_pages: 0,
				total_results: 0,
			},
			page: 1,
			loading: true,
			sort:'start_date',
			sort_direction:'-',
			needs_refresh: false,
			pending_search: '',
			search:'',
			supress_requests: true,
		};
	},
	methods:{
		openDetailsModal: function(id){
			$.magnificPopup.open({
				items: {
					src: $('#popupDescription' + id),
					type: 'inline'
				}
			});
		},
		doSort:function(sort){
			this.page = 1;
			if (this.sort == sort) {
				if (this.sort_direction === '') {
					this.sort_direction = '-';
				}
				else{
					this.sort_direction = '';
				}
			}
			else{
				this.sort = sort;
			}
			this.getData();
		},
		getData: function(){
			if (this.supress_requests) {
				return;
			}
			this.loading = true;
			var self = this;
			var qs = "";
			qs += "&page=" + self.page;
			qs+="&sort[]=" + self.sort_direction + self.sort;

			if (self.search) {
				qs += "&search=" + encodeURI(self.search);
			}


			this.API({
				endpoint: 'projects',
				querystring: qs,
				funcThen: function(response){
					self.meta = response.data.meta;
					self.projects = response.data.projects;
				},
				funcAfterThen: function(){
					self.loading = false;
				}
			});
		},
		doSearch: function(){
			this.search = this.pending_search;
		}
	},
	computed: {
		max_page: function(){
			return this.meta.total_pages;
		}
	},
	watch:{
		page: function(){
			let query = Object.assign({}, this.$route.query);
			query.page = this.page;
			this.$router.replace({query: query});
			this.getData();
		},
		sort: function(){
			let query = Object.assign({}, this.$route.query);
			query.sort = this.sort;
			this.$router.replace({query: query});
			this.getData();
		},
		sort_direction: function(){
			let query = Object.assign({}, this.$route.query);
			if (this.sort_direction == "") {
				query.sort_direction = "+";
			}
			else{
				query.sort_direction = this.sort_direction;
			}
			this.$router.replace({query: query});
			this.getData();
		},
		search: function(){
			if (this.supress_requests) {
				this.page = 1;
			}
			else{
				this.supress_requests = true;
				this.page = 1;
				this.supress_requests = false;
			}

			let query = Object.assign({}, this.$route.query);
			query.search = this.search;
			this.$router.replace({query: query});
			this.getData();
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Projects.vue